
    import { Component, Vue, Prop, Watch } from 'vue-facing-decorator';
    import { Action } from '@/plugins/vuex-decorators';

    const namespace = 'main';

    @Component
    export default class WhoHasAccess extends Vue {
        @Prop({ default: null }) public modelAccess: any;
        @Prop({ default: null }) public model: any;
        @Action('closeModelAccess', { namespace }) closeModelAccess: any;

        private modalShow = false;

        private mounted() {
            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape") if (this.modalShow) this.close();
            });
        }

        @Watch('modelAccess')
        private onModelAccessChanged(value: any) {
            this.modalShow = value != null;
        }

        private get roles(): any[] {
            return this.modelAccess ? this.modelAccess.roles : [];
        }

        private get users(): any[] {
            return this.modelAccess ? this.modelAccess.users : [];
        }

        // The group(s) that grant `roleName` to `user` on this model — empty when the user lacks the role.
        private grantingGroups(user: any, roleName: string): string[] {
            const match = (user.roles || []).find((r: any) => r.roleName === roleName);
            return match ? match.grantedByGroups : [];
        }

        private close() {
            this.closeModelAccess();
        }
    }
